import React from "react";
import { defineMessages } from "react-intl";
import { Divider } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import "../../../components/alerts/InfoMessage.js";
import "../../../components/alerts/NoAccessInfoMessage.js";
import "../../../components/alerts/Message.style.js";
import { ErrorAlert, SuccessAlert } from "../../../components/alerts/InfoAlert.js";
import "../../../components/alerts/InfoMessageHoc.js";
import { TransactionType } from "../../../contract/pam.js";
import "../../bulk-operation/actions.js";
import "../../bulk-operation/components/BulkActionButton.js";
import "../../bulk-operation/epics.js";
import "../../bulk-operation/hooks.js";
import "../../bulk-operation/reducers.js";
import "../../bulk-operation/selectors.js";
import "rxjs";
import "rxjs/operators";
import "../../../api/types.js";
import "immer";
import "moment-timezone";
import { useNumberFormatter } from "../../../utils/number.js";
import "@apollo/client/errors";
import "@apollo/client";
import "graphql";
import "@opentelemetry/api";
import "../../../otel/TraceProvider.js";
import "react-error-boundary";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import "../../bulk-operation/components/BulkExecutionStepDetailsContent.js";
import "../../bulk-operation/components/BulkExecutionStepModal.js";
import "../../bulk-operation/components/BulkSummaryStepActionItem.js";
import "../../bulk-operation/components/BulkSummaryStepHoc.js";
import "../../../components/chip/ChipRenderer.js";
import "../../../components/chip/Chips.js";
import "../../../components/chip/ListWithChipTooltip.js";
import "../../../components/chip/SquaredChipList.js";
import "../../../components/icons/Icon.js";
import "../../../components/icons/ExpandMoreIcon.js";
import "../../bulk-operation/components/DataGrid.js";
import { BulkStepValidationSummarySuccess, BulkStepValidationSummaryFailed, BulkStepValidationTotalSummary } from "../../bulk-operation/components/BulkStepValidationSummary.js";
import "../../../components/progress/CircularProgress.js";
import "../../../components/progress/CircularProgressWithLabel.js";
import "../../bulk-operation/components/BulkSummaryStepActionLabel.js";
import { getValidationErrorItems } from "../hooks.js";
import { DataGridBulkTransactionsClient } from "./DataGridWithBulkResults.js";
const localizedBulkStepValidation = defineMessages({
  uidNotExists: {
    id: "BulkTransactionValidationStep_uidNotExists",
    defaultMessage: "UID doesn't exist"
  },
  balanceIsNotEnough: {
    id: "BulkTransactionValidationStep_balanceIsNotEnough",
    defaultMessage: "Not enough funds"
  },
  amountNotInteger: {
    id: "BulkTransactionValidationStep_amountNotInteger",
    defaultMessage: "Please use number without separators, coma and period"
  },
  amountNotNumber: {
    id: "BulkTransactionValidationStep_amountNotNumber",
    defaultMessage: "Please use integer or decimal number with point separator"
  },
  amountNotPositive: {
    id: "BulkTransactionValidationStep_amountNotPositive",
    defaultMessage: "Please put amount > 0"
  },
  amountDecimalPartLengthIsNotValid: {
    id: "BulkTransactionValidationStep_amountDecimalPartLengthIsNotValid",
    defaultMessage: "Please put amount with decimal part length <= 2"
  },
  typeIsNotValid: {
    id: "BulkTransactionValidationStep_typeIsNotValid",
    defaultMessage: "Invalid input"
  },
  reasonCodeIsNotValid: {
    id: "BulkTransactionValidationStep_reasonCodeIsNotValid",
    defaultMessage: "Invalid reason codes"
  },
  lineIsTooLarge: {
    id: "BulkTransactionValidationStep_lineIsTooLarge",
    defaultMessage: "Currently batch only supports less than {maxTransactionLines} transaction lines. Please reduce the transaction line"
  },
  transactionsValidated: {
    id: "BulkTransactionValidationStep_transactionsValidated",
    defaultMessage: "Transactions successfully validated"
  },
  transactionsNotValidated: {
    id: "BulkTransactionValidationStep_transactionsNotValidated",
    defaultMessage: "Transactions not validated"
  },
  totalCredit: {
    id: "BulkTransactionValidationStep_totalCredit",
    defaultMessage: "Total amount of credit"
  },
  totalDebit: {
    id: "BulkTransactionValidationStep_totalDebit",
    defaultMessage: "Total amount of debit"
  },
  amountIsTooLarge: {
    id: "BulkTransactionValidationStep_amountIsTooLarge",
    defaultMessage: "Single Line Transaction amount > ${amount}"
  },
  totalIsTooLarge: {
    id: "BulkTransactionValidationStep_totalIsTooLarge",
    defaultMessage: "Transaction amount exceeded remaining available daily credit"
  },
  duplicatesNotAllowed: {
    id: "BulkTransactionValidationStep_duplicatesNotAllowed",
    defaultMessage: "Transfer failed. Duplicate user IDs detected in the CSV. Please ensure each recipient appears only once."
  },
  downlinePlayersOnlyAllowed: {
    id: "BulkTransactionValidationStep_downlinePlayersOnlyAllowed",
    defaultMessage: "Transfer failed. Some recipients are not downlines of your account. Please verify the CSV and try again."
  },
  uploadedDataIsInvalid: {
    id: "BulkTransactionValidationStep_uploadedDataIsInvalid",
    defaultMessage: "Transfer failed. Uploaded data is invalid. Please verify the CSV and try again."
  },
  playerNotInP2PChannel: {
    id: "BulkTransactionValidationStep_playerNotInP2PChannel",
    defaultMessage: "UID {uid} must be in P2P currency channel."
  }
});
const useBulkStepValidationContentStyles = makeStyles()((theme) => ({
  bulkStepValidationContentResultContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    marginTop: theme.spacing(2)
  },
  bulkStepValidationContentResultTitle: {
    display: "flex",
    alignItems: "center",
    columnGap: theme.spacing(1.5)
  },
  bulkStepValidationContentResultSubtitle: {
    marginTop: theme.spacing(1)
  },
  bulkStepValidationContentDivider: {
    marginTop: theme.spacing(2)
  },
  bulkStepValidationContentResultIcon: {
    fontSize: "1.5em"
  },
  bulkStepValidationContentResultChip: {
    display: "flex",
    columnGap: theme.spacing(0.75),
    rowGap: theme.spacing(1.25),
    flexWrap: "wrap"
  },
  bulkStepValidationContentGrid: {
    marginTop: theme.spacing(2.5),
    padding: 0,
    height: "380px",
    display: "flex",
    flexDirection: "column"
  }
}));
function BulkStepValidationContentSuccessful({ validTransactions, alertTitle }) {
  const { classes } = useBulkStepValidationContentStyles();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(SuccessAlert, { title: alertTitle }), /* @__PURE__ */ React.createElement(BulkStepValidationSummarySuccess, { title: localizedBulkStepValidation.transactionsValidated, count: validTransactions.length }), /* @__PURE__ */ React.createElement(Divider, { className: classes.bulkStepValidationContentDivider }), /* @__PURE__ */ React.createElement(ValidationFinancialSummary, { transactions: validTransactions.map((r) => r.item) }));
}
function BulkStepValidationContentFailed({
  validTransactions,
  invalidTransactions,
  gridColumns,
  alertTitle
}) {
  const { classes } = useBulkStepValidationContentStyles();
  const errorItems = getValidationErrorItems(invalidTransactions);
  const maxRows = 100;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ErrorAlert, { title: alertTitle }), /* @__PURE__ */ React.createElement(BulkStepValidationSummarySuccess, { title: localizedBulkStepValidation.transactionsValidated, count: validTransactions.length }), /* @__PURE__ */ React.createElement(Divider, { className: classes.bulkStepValidationContentDivider }), /* @__PURE__ */ React.createElement(
    BulkStepValidationSummaryFailed,
    {
      subtitle: localizedBulkStepValidation.transactionsNotValidated,
      count: invalidTransactions.length
    }
  ), /* @__PURE__ */ React.createElement(
    ValidationFinancialSummary,
    {
      transactions: [...validTransactions, ...invalidTransactions].map((r) => r.item)
    }
  ), /* @__PURE__ */ React.createElement(
    DataGridBulkTransactionsClient,
    {
      columns: gridColumns,
      rows: errorItems,
      rawModels: errorItems?.map((i) => ({ isValid: true, raw: JSON.stringify(i) })),
      rowsPerPageOptions: [maxRows],
      hidePagination: errorItems.length < maxRows,
      className: classes.bulkStepValidationContentGrid,
      isFlexible: true
    }
  ));
}
function ValidationFinancialSummary({ transactions }) {
  const currency = "USD";
  const { formatNumber } = useNumberFormatter();
  function getTotalAmount(transactions2, types) {
    return transactions2.filter((t) => types.includes(t.type) || types.includes(t.transaction_type)).reduce((sum, item) => sum + Number(item.amount), 0);
  }
  const totalCreditAmount = getTotalAmount(transactions, [TransactionType.Credit, TransactionType.P2PTransferCredit]);
  const totalDebitAmount = getTotalAmount(transactions, [TransactionType.Debit, TransactionType.P2PTransferDebit]);
  return /* @__PURE__ */ React.createElement(
    BulkStepValidationTotalSummary,
    {
      items: [
        {
          label: localizedBulkStepValidation.totalCredit,
          value: formatNumber(totalCreditAmount ?? 0, { style: "currency", currency })
        },
        {
          label: localizedBulkStepValidation.totalDebit,
          value: formatNumber(totalDebitAmount ?? 0, { style: "currency", currency })
        }
      ]
    }
  );
}
export {
  BulkStepValidationContentFailed,
  BulkStepValidationContentSuccessful,
  localizedBulkStepValidation
};
//# sourceMappingURL=BulkValidationStepContent.js.map
